import { render, staticRenderFns } from "./AddPinBatch.vue?vue&type=template&id=2d254505&scoped=true"
import script from "./AddPinBatch.vue?vue&type=script&lang=js"
export * from "./AddPinBatch.vue?vue&type=script&lang=js"
import style0 from "./AddPinBatch.vue?vue&type=style&index=0&id=2d254505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d254505",
  null
  
)

export default component.exports